import { ValidationErrorsDialog } from '../ValidationErrorsDialog'
import { DiscardDraftDialog } from './DiscardDraftDialog'
import { UpdateImpactDialog } from './UpdateImpactDialog'
import type { useCourseUpdate } from './useCourseUpdate'

interface Props {
  update: ReturnType<typeof useCourseUpdate>
  discardOpen: boolean
  onDiscardOpenChange: (open: boolean) => void
  onDiscard: () => void
}

/** Диалоги секции «Изменения»: ущерб ученикам, отмена правок, ошибки валидатора. */
export const DraftChangesDialogs = ({
  update,
  discardOpen,
  onDiscardOpenChange,
  onDiscard,
}: Props) => (
  <>
    <UpdateImpactDialog
      impact={update.impact}
      onConfirm={() => void update.confirmSubmit()}
      onCancel={update.cancelImpact}
    />
    <DiscardDraftDialog
      open={discardOpen}
      onOpenChange={onDiscardOpenChange}
      onConfirm={onDiscard}
    />
    <ValidationErrorsDialog
      open={update.validationErrors.length > 0}
      errors={update.validationErrors}
      onClose={update.clearValidationErrors}
    />
  </>
)
